import { registerComponent, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "image-hover-zoom",
  class ImageHoverZoom extends WYATTElement {
    connectedCallback() {
      this.zoomImage = this.querySelector("[data-zoom-image]");
      this.zoomImageUrl = this.zoomImage.dataset.zoomImage;
      this.setAttribute("data-zoom-image-active", false);

      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener("pointerup", this.handleClick.bind(this));
      this.addEventListener("mousemove", this.handleMove.bind(this));
      this.zoomImage.addEventListener("touchmove", this.handleMove.bind(this));
      this.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
    }

    handleClick() {
      if (this.dataset.zoomImageActive === "true") {
        this.hideZoomImage();
      } else {
        this.showZoomImage();
      }
    }

    handleMove(e) {
      e.preventDefault();
      let clientX;
      let clientY;

      if (e.touches) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else {
        clientX = e.clientX;
        clientY = e.clientY;
      }

      this.moveImage(clientX, clientY);
    }

    handleMouseLeave() {
      this.hideZoomImage();
    }

    showZoomImage() {
      loading.add(this);
      this.zoomImage.style.backgroundImage = `url(${this.zoomImageUrl})`;
      this.zoomImage.style.display = "block";
      this.setAttribute("data-zoom-image-active", true);
    }

    hideZoomImage() {
      loading.remove(this);
      this.zoomImage.style.display = "none";
      this.zoomImage.style.backgroundImage = "";
      this.setAttribute("data-zoom-image-active", false);
    }

    moveImage(clientX, clientY) {
      const dimensions = this.getBoundingClientRect();
      const x = clientX - dimensions.left;
      const y = clientY - dimensions.top;
      const xPercent = 100 / (dimensions.width / x);
      const yPercent = 100 / (dimensions.height / y);

      this.zoomImage.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    }
  },
);
